export const STORAGE_KEY = 'jwm.sidebar';
export const SIDEBAR_MIN_WIDTH_OLD = 360;
export const SIDEBAR_MIN_WIDTH = 435;
